export enum FilterPeriod {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum Period {
  YESTERDAY = 'yesterday',
  LAST_WEEK = 'lastWeek',
  LAST_MONTH = 'lastMonth',
  SEVEN_DAYS = 'sevenDays',
  FOURTEEN_DAYS = 'fourteenDays',
  THIRTY_DAYS = 'thirtyDays',
  SIXTY_DAYS = 'sixtyDays',
  NINETY_DAYS = 'ninetyDays',
  CUSTOM = 'custom',
}

export interface DateFilterValue {
  period: Period;
  startDate: string;
  endDate: string;
}
